// extracted by mini-css-extract-plugin
export default {"sub-page-content":"styles_sub-page-content__2bY2B","form-control-container":"styles_form-control-container__VGO8f"};